import DOMPurify from 'dompurify';

export function cleanHTML(html: string) {
  if (typeof window === 'undefined') return '';

  // Sanitize first so scripts and event handlers never reach a live DOM node
  const sanitized = DOMPurify.sanitize(html, { FORBID_ATTR: ['style'] });

  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = sanitized;

  // Remove all font-related attributes and tags
  tempDiv.querySelectorAll('span, font').forEach((el) => {
    el.replaceWith(...el.childNodes);
  });

  return tempDiv.innerHTML;
}
